import { Link } from "react-router-dom";
import type { ManhwaWork } from "@/mocks/works";

export default function WorkCard({ work }: { work: ManhwaWork }) {
  return (
    <article
      data-product-shop
      className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={work.image}
          alt={`${work.title} 韩漫封面`}
          title={`${work.title} 人气韩漫`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-semibold text-background-50 ${
            work.status === "已完结" ? "bg-secondary-500" : "bg-accent-500"
          }`}
        >
          {work.status}
        </span>
        <span className="absolute bottom-3 left-3 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-star-fill mr-1 text-secondary-400"></i>
          {work.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-4">
        <h3 className="truncate font-heading text-base font-bold text-foreground-950">{work.title}</h3>
        <p className="mt-0.5 truncate text-xs text-foreground-500">{work.original}</p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{work.summary}</p>
        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          {work.genres.slice(0, 2).map((g) => (
            <span key={g} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
              {g}
            </span>
          ))}
          <span className="ml-auto text-xs text-foreground-400">{work.episodes}</span>
        </div>
      </div>
    </article>
  );
}